import React, { FC } from 'react';
import Modal from '~ComponentsImproved/Modal';
import useModal from '~ComponentsImproved/Modal/useModal';
import { PopupContent } from './styles';
import Button from '~ComponentsImproved/Button';
import { useI18n } from '~Hooks';

interface Props {
  isShowing: boolean;
  toggle: () => void;
}

const DemoNoPaymentsAllowed: FC<Props> = ({ isShowing, toggle }) => {
  const { i18n } = useI18n();

  return (
    <Modal isShowing={isShowing} backdropClose={true} hide={toggle}>
      <PopupContent>
        <h2>{i18n('DemoMode.Name')}</h2>
        <p>{i18n('DemoMode.NoPayments')}</p>
        <Button width="200px" styleType="OK" onTouchStart={toggle}>
          {i18n('DemoMode.NoPayments.Button')}
        </Button>
      </PopupContent>
    </Modal>
  );
};

export default DemoNoPaymentsAllowed;
